export default "__VITE_ASSET__BP_4hWCu__"